// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4_4At","content":"styles_content__3r9B4"};